export default __webpack_public_path__ + "static/media/people4full.3fa3f6bd.jpg";